import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=29bf8baa&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=29bf8baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf8baa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29bf8baa')) {
      api.createRecord('29bf8baa', component.options)
    } else {
      api.reload('29bf8baa', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=29bf8baa&scoped=true&", function () {
      api.rerender('29bf8baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8qQoQNTxTaJv9/JS/teamMember.vue"
export default component.exports